import React, { useRef, useState } from "react";

import { mdiInformationOutline, mdiPencil } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import FooterDisposition from "./headerFooter/FooterDisposition";
import HeaderDisposition from "./headerFooter/HeaderDisposition";
import Block from "../../../components/block/Block";
import { PROJECTS_ROUTE } from "../../../components/routes/routes";
import Breadcrumbs from "../../../components/utils/Breadcrumbs";
import ContainerHeader from "../../../components/utils/ContainerHeader";
import { CONTENT_MAX_WIDTH_STYLE } from "../../../constants/size";

import type { JSX } from "react";

import type { FooterDispositionRef } from "./headerFooter/FooterDisposition";
import type { HeaderDispositionRef } from "./headerFooter/HeaderDisposition";

function HeaderFooterDisposition(): JSX.Element {
  const { projectSlug } = useParams<{
    projectSlug: string;
  }>();
  const { t } = useTranslation("editor-platform");
  const history = useHistory();
  const [isPending, setIsPending] = useState(false);

  const headerDispositionRef = useRef<HeaderDispositionRef>(null);
  const footerDispositionRef = useRef<FooterDispositionRef>(null);

  const itemHeader = {
    label: t("header_footer"),
  };

  const breadcrumbs = [
    {
      name: t("editor-menu:platform"),
      url: "/layout",
    },
    {
      name: t("title.layout"),
      url: "/layout",
    },
    {
      name: itemHeader.label,
    },
  ];

  const editProject = (): void => {
    history.push(`${PROJECTS_ROUTE}/${projectSlug}/edit`);
  };

  const handleSave = async (): Promise<void> => {
    try {
      setIsPending(true);
      const promises: Promise<void>[] = [];
      if (headerDispositionRef.current) {
        promises.push(headerDispositionRef.current.onSave());
      }
      if (footerDispositionRef.current) {
        promises.push(footerDispositionRef.current.onSave());
      }
      await Promise.all(promises);
    } catch (error) {
      console.error("Error saving header/footer disposition:", error);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div
      className="mx-auto size-full max-w-(--maxWidth) overflow-y-auto px-[60px] pt-[30px] pb-[60px]"
      style={CONTENT_MAX_WIDTH_STYLE}
    >
      <Breadcrumbs items={breadcrumbs} />
      <ContainerHeader
        withBackBtn
        item={itemHeader}
        loading={isPending}
        onSave={handleSave}
      />
      <div className="flex flex-col gap-6.25">
        <HeaderDisposition ref={headerDispositionRef} />
        <FooterDisposition ref={footerDispositionRef} />
        <Block>
          <div className="flex gap-[0.46875rem]">
            <Icon path={mdiInformationOutline} size={0.875} />
            <div className="flex items-center gap-1.25">
              {t("manageLinksPart1")}
              <button
                className="text-primary flex cursor-pointer items-center gap-1.25 hover:underline"
                onClick={editProject}
                type="button"
              >
                {t("manageLinksPart2")}
                <Icon path={mdiPencil} size={0.625} />
              </button>
            </div>
          </div>
        </Block>
      </div>
    </div>
  );
}

export default HeaderFooterDisposition;
